<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="goods-list">
        <div
          v-for="(item, index) in AllList"
          :key="index"
          class="goods-item d-flex flex-row justify-content-between align-items-center"
        >
          <div class="flex-1 d-flex flex-column">
            <div style="font-size: 14px">{{ item.actionTypeName }}</div>
            <div style="font-size: 14px" class="timeStr">
              {{ item.createTime }}
            </div>
          </div>
          <div>{{ item.amount }}积分</div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
export default {
  data() {
    return {
      AllList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
    };
  },

  created() {},
  methods: {
    async onLoad() {
      try {
        if (this.refreshing) {
          this.AllList = [];
          this.page = 1;
          this.refreshing = false;
        }
        let params = {
          page: this.page,
          size: 10,
        };
        const { data } = await this.$http.request(
          this.$http.pathMap.pointLog,
          "get",
          params
        );
        this.AllList = [...this.AllList, ...data.list];
        this.loading = false;
        this.refreshing = false;
        if (data.hasNextPage) {
          this.page++;
        } else {
          this.finished = true;
        }
      } catch (error) {
        return error;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 分类 */
/* 商品列表 */
.goods-list {
  padding: 0 15px;
  background: #fff;
  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 5px 10px;
    border-bottom: 1px rgba(230, 230, 230, 1) solid;
    .timeStr {
      color: $font-color-light;
      font-size: $uni-font-size-lg;
    }
  }
}
</style>
